const html = require('choo/html')
const requestMic = require('./utility/requestMic.js')

module.exports = function store(state, emitter) {
  state.tutorialSteps = []

  emitter.on('starttutorial', () => {
    console.log('starttutorial')
    state.isSoundLibraryOpen = false
    state.isRecordingOpen = false
    state.tutorialSteps = [
      {
        position: ['top', 'right'],
        message: "Click on the SPACE button or press SPACE on your keyboard to trigger a sound.",
        el: '#space-button',
        onComplete: () => {
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      },
      {
        position: ['top', 'right'],
        message: "Toggle SHUFFLE to play the sounds randomly or in order.",
        el: '#shuffle'
      },
      {
        position: ['top', 'right'],
        message: "You can add additional sounds from the sound library.",
        el: '#sampler-board #open-library',
        onComplete: () => {
          state.isSoundLibraryOpen = true
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      },
      {
        position: ['top', 'right'],
        message: "Click on a sample to select and play it.",
        el: '#sound-library #sound-list'
      },
      {
        position: ['top', 'right'],
        message: "Click and drag the sample to the SPACE button to add it to your playlist.",
        el: '#customizing',
        onComplete: () => {
          state.isSoundLibraryOpen = false
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      },
      {
        position: ['top', 'right'],
        message: "You can also record your own samples.",
        el: '#open-recording',
        onComplete: () => {
          requestMic()
            .then(() => {
              state.isSoundLibraryOpen = false
              state.isRecordingOpen = true
              emitter.emit('render')
            })
            .catch(() => {
              emitter.emit('canceltutorial')
            })
        }
      },
      {
        position: ['top', 'left'],
        message: `Click and hold the RECORD button to capture a sample.`,
        el: '#hold-to-record'
      },
      {
        position: ['top', 'left'],
        message: `Press the TEST button to see how it sounds.`,
        el: '#press-to-test'
      },
      {
        position: ['top', 'left'],
        message: `Click on the wave form to start your sample from there.`,
        el: '#wave-preview'
      },
      {
        position: ['top', 'left'],
        message: `When you like how it sounds, give your sample a name and save it to your sample library.`,
        el: '#recording'
      },
      {
        position: ['top', 'right'],
        message: `You're done!  You can drag your recording from the sample library to the SPACE button to add them to your playlist.`,
        el: '#sampler-board',
        onComplete: () => {
          state.isSoundLibraryOpen = false
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      }
    ]
    emitter.emit('render')
  })

  emitter.on('nexttutorial', () => {
    console.log('nexttutorial')
    if (state.tutorialSteps[0]) {
      if (state.tutorialSteps[0].onComplete) {
        state.tutorialSteps[0].onComplete()
        // Wait until transition animation ends
        setTimeout(() => {
          state.tutorialSteps.shift()
          emitter.emit('render')
        }, 250)
      } else {
        state.tutorialSteps.shift()
        emitter.emit('render')
      }
    }
    emitter.emit('unfocus')
  })

  emitter.on('canceltutorial', () => {
    console.log('canceltutorial')
    state.tutorialSteps = []
    emitter.emit('render')
  })
};
